// modSelectors.js

export const selectLevelData = (state) => state.training.availableLevels;
export const selectAllTrainingsData = (state) => state.training.allTrainings;
export const selectAllTrainingsWithTitleData = (state) =>
  state.training.allTrainingsWithTitle;
export const selectLoading = (state) => state.training.loading;
export const selectAllMasterclassTrainings = (state) =>
  state.training.allMasterclassTrainings;
export const selectMasterclassLoading = (state) =>
  state.training.masterclassLoading;
export const selectMasterclassError = (state) =>
  state.training.masterclassError;
export const selectLevel = (state) => state.training.selectedLevel;